import Keycloak, { KeycloakLoginOptions } from "keycloak-js";
import { env } from "config";
import { getKeycloakLocale } from "services/region/region";

export const client = Keycloak({
  url: env.REACT_APP_KEYCLOAK_URL,
  realm: env.REACT_APP_KEYCLOAK_REALM || "",
  clientId: env.REACT_APP_KEYCLOAK_CLIENT_ID || "",
});

// Every login() call site should request the instance language on the Keycloak pages
// (ui_locales). Wrapping login() here keeps the call sites untouched; on the global
// instance the locale is undefined and the query parameter is not sent at all.
const originalLogin = client.login.bind(client);
client.login = (options?: KeycloakLoginOptions) =>
  originalLogin({ locale: getKeycloakLocale(), ...options });

client.onTokenExpired = () => {
  console.log("Token expired!");

  client.updateToken(30)
    .then((refreshed) => {
      if (refreshed) {
        console.log("Token was successfully refreshed");
      } else {
        console.log("Token is still valid");
      }
    })
    .catch(() => client.login({
      redirectUri: window.location.origin,
    }));
};
